import { CreditEventSource, CreditEventType } from 'constants/loanApplication';

export const DEROGATORY_EVENTS_TITLE = 'Derogatory events from the credit report';

export const NO_DEROGATORY_EVENTS_TEXT = 'No derogatory events on the credit report.';

export const DEROGATORY_EVENT_TYPE_LABELS = {
  [CreditEventType.BANKRUPTCY]: 'Bankruptcy',
  [CreditEventType.FORECLOSURE]: 'Foreclosure',
  [CreditEventType.SHORT_SALE]: 'Short sale',
  [CreditEventType.DEED_IN_LIEU]: 'Deed-in-lieu',
};

export const DEROGATORY_EVENT_SOURCE_LABELS = {
  [CreditEventSource.PUBLIC_RECORD]: 'Public record',
  [CreditEventSource.ACCOUNT_STATUS]: 'Account status',
  [CreditEventSource.RATING]: 'Payment rating',
  [CreditEventSource.COMMENT]: 'Bureau comment',
};

export const DerogatoryEventsColumn = {
  EVENT: 'event',
  DATES: 'dates',
  RELIABILITY: 'reliability',
  SOURCE: 'source',
  DETAILS: 'details',
};
